import { useEffect, useState } from 'react'
import { Modal, Header, ModalContent } from './styles'
import CloseButton from 'src/global/CloseButton'
import { useSelector } from 'react-redux'
import { State } from 'src/state'
import { Backdrop } from 'src/global'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import MdToggle from '../MdToggle'
import { productsSelector } from 'src/state/selectors'
import BasicSettings from './BasicSettings'
import GeneralSettings from './GeneralSettings'
import AdvancedSettings from './AdvancedSettings'

export type SettingsTab = 'basic' | 'general' | 'advanced'

const TAB_OPTIONS = [
  { value: 'basic', label: 'De bază' },
  { value: 'general', label: 'Generale' },
  { value: 'advanced', label: 'Avansate' },
]

export default function SettingsModal() {
  const [isOpen, setIsOpen] = useState(false)
  const [activeTab, setActiveTab] = useState<SettingsTab>('general')
  const [isContentScrolled, setIsContentScrolled] = useState(false)

  const { user, isLoading: isLoadingUser } = useSelector((state: State) => state.users)
  const { isLoading: isLoadingProducts } = useSelector(productsSelector)

  useEffect(() => {
    window.openSettingsModal = open
    window.hideSettingsModal = close
  }, [])

  // A tab opens the modal straight on it; without one the modal keeps the last tab
  const open = (tab?: SettingsTab) => {
    if (tab) {
      setActiveTab(tab)
    }
    setIsContentScrolled(false)
    setIsOpen(true)
  }

  const close = () => {
    setIsOpen(false)
  }

  if (!user) {
    return null
  }

  return (
    <>
      <Backdrop onClick={close} className={isOpen ? 'open' : 'closed'} />
      <Modal className={isOpen ? 'open' : 'closed'}>
        <Header>
          Setări
          <CloseButton onClick={close} title="Închide" style={{ marginTop: '-18px' }} />
        </Header>
        {isOpen && (
          <>
            <div className="toggle-wrapper">
              <MdToggle options={TAB_OPTIONS} value={activeTab} onChange={value => setActiveTab(value as SettingsTab)} />
            </div>
            <div className={`scroll-fade ${isContentScrolled ? 'visible' : ''}`} />
            <ModalContent onScroll={e => setIsContentScrolled(e.currentTarget.scrollTop > 0)}>
              {activeTab === 'basic' && <BasicSettings />}
              {activeTab === 'general' && <GeneralSettings />}
              {activeTab === 'advanced' && <AdvancedSettings />}
              {activeTab !== 'basic' && (
                <div className="auto-save" style={{ opacity: isLoadingUser || isLoadingProducts ? 0 : 1 }}>
                  <FontAwesomeIcon icon={faCheckCircle} />
                  Toate modificările au fost salvate.
                </div>
              )}
            </ModalContent>
          </>
        )}
      </Modal>
    </>
  )
}
